import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-49bfe184")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    style: $props.baserecstyle,
    class: "baserectangle p-col-12"
  }, [
    _createVNode("span", {
      style: $props.recstyle,
      class: "rectangle"
    }, null, 4)
  ], 4))
})